import styled from 'styled-components'

import { InfoMessage } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

export type CommentsThreadErrorProps = {} & ClassNameProps

export const CommentsThreadError = ({
  className,
}: CommentsThreadErrorProps) => (
  <Root className={className}>
    <InfoMessage intent="error" variant="dt" />
  </Root>
)

const Root = styled.div`
  display: grid;
  border-top: 1px solid var(--background-3);
`
